import { Directive, Input } from "@angular/core";

/** Interface defining the type of template context used for body */
interface TableRowTemplateContext<Titem extends object> {
    $implicit: Titem;
    expanded?: boolean;
    rowIndex: number;
}

@Directive({
    selector: "ng-template[appTableRow]",
})
export class TableRowDirective<Titem extends object> {
    @Input("appTableRow") items!: Titem[];

    static ngTemplateContextGuard<TContextItem extends object>(
        dir: TableRowDirective<TContextItem>,
        ctx: unknown,
    ): ctx is TableRowTemplateContext<TContextItem> {
        return true;
    }
}
